import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import useAPI from "../../Hooks/useAPI";
import Header2 from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import {
  faArrowLeft,
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../Components/Page/Page.css";
import "./ContactManagement.css";
import "./ContactMatch.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { cp } from "fs/promises";
// import { A } from "framer-motion/dist/types.d-B50aGbjN";
//import { A, n } from "framer-motion/dist/types.d-B50aGbjN";
import Table from "../../Components/Tables/Table";

interface ContactsToMatch {
  cidn1: number;
  firstname1: string;
  lastname1: string;
  middlename1: string;
  cidn2: number;
  firstname2: string;
  lastname2: string;
  middlename2: string;
  score: number;
}

interface Contact {
  cidn: number;
  ipaddress: string;
  firstname: string;
  firstnameselected: boolean;
  lastname: string;
  lastnameselected: boolean;
  middlename?: string;
  middlenameselected: boolean;
  contacttype?: string;
  profession: string[];
  profession_other?: string;
  interests: string[];
  interests_other?: string;
  valid: boolean;
  email: string;
  companyname?: string;
  title?: string;
  entitytype?: string;
  dateadded: string;
  dateupdated: string;
  hasuser: boolean;
  streetaddress: string;
  streetaddress2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phonenumber: string;
  datasource: string;
}

interface Contact2 {
  cidn: number;
  ipaddress: string;
  firstname: string;
  firstnameselected: boolean;
  lastname: string;
  lastnameselected: boolean;
  middlename?: string;
  middlenameselected: boolean;
  contacttype?: string;
  profession: string[];
  profession_other?: string;
  interests: string[];
  interests_other?: string;
  valid: boolean;
  email: string;
  companyname?: string;
  title?: string;
  entitytype?: string;
  dateadded: string;
  dateupdated: string;
  hasuser: boolean;
  streetaddress: string;
  streetaddress2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phonenumber: string;
  datasource: string;
}

interface ContactAddress {
  contactaddressid: number;
  streetaddress?: string;
  streetaddress2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  primaryind: boolean;
  addressselected: boolean;
}

interface ContactAddress2 {
  contactaddressid: number;
  streetaddress?: string;
  streetaddress2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  primaryind: boolean;
  addressselected: boolean;
}

interface ContactEmail {
  contactemailid: number;
  email?: string;
  primaryind: boolean;
  emailselected: boolean;
}

interface ContactEmail2 {
  contactemailid: number;
  email?: string;
  primaryind: boolean;
  emailselected: boolean;
}

interface ContactPhone {
  contactphoneid: number;
  phonenumber?: string;
  countrycode?: string;
  phoneext?: string;
  primaryind: boolean;
  phoneselected: boolean;
}

interface ContactPhone2 {
  contactphoneid: number;
  phonenumber?: string;
  countrycode?: string;
  phoneext?: string;
  primaryind: boolean;
  phoneselected: boolean;
}

interface ContactCompany {
  contactcompanyid: number;
  companyname?: string;
  entityid?: number;
  entitytype?: string;
  title?: string;
  primaryind: boolean;
  companyselected: boolean;
}
interface ContactCompany2 {
  contactcompanyid: number;
  companyname?: string;
  entityid?: number;
  entitytype?: string;
  title?: string;
  primaryind: boolean;
  companyselected: boolean;
}
interface ContactList {
  cidn: string;
  firstname: string;
  lastname: string;
  email: string;
}

// Define props for ContactOption
interface UserOption {
  id: string;
  firstlastemail: string;
  cidn: number;
}

// Define props for States
interface StateOption {
  stateprovinceabbrv: string;
  stateprovincename: string;
}

// Define props for ContactOption
interface ContactOption {
  cidn: string;
  firstname: string;
  lastname: string;
  middlename?: string;
  email: string;
}

export default function ContactMatch() {
  const location = useLocation();
  const [contacts, setContacts] = useState<ContactsToMatch[]>([]);
  const [contact, setContact] = useState<Contact | null>(null);
  const [contact2, setContact2] = useState<Contact2 | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [isAddingContact, setIsAddingContact] = useState(false);
  const [contactdropdown, setContactDropDown] = useState<ContactOption[]>([]);
  const [contactmatchdropdown, setContactMatchDropDown] = useState<
    ContactOption[]
  >([]);

  const [newContact, setNewContact] = useState<ContactList>({
    cidn: "",
    firstname: "",
    lastname: "",
    email: "",
  });

  const [newContactMatch, setNewContactMatch] = useState<ContactList>({
    cidn: "",
    firstname: "",
    lastname: "",
    email: "",
  });

  const [sortConfig, setSortConfig] = useState<{
    key: keyof ContactsToMatch | null;
    direction: "ascending" | "descending" | null;
  }>({
    key: null,
    direction: null,
  });

  const { user } = useUser();
  const [ViewDetails, setViewDetails] = useState(false);
  const [selectedcidn1, setSelectedCidn1] = useState<number>(0);
  const [selectedcidn2, setSelectedCidn2] = useState<number>(0);
  const [contactaddress, setContactAddress] = useState<ContactAddress[]>([]);
  const [contactaddress2, setContactAddress2] = useState<ContactAddress2[]>([]);

  const [states, setStates] = useState<StateOption[]>([]);

  // Fetch states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await getStateProvince();
        setStates(response);
      } catch (error) {
        console.error("Error loading states:", error);
      }
    };
    fetchStates();
  }, []);

  const [contactemail, setContactEmail] = useState<ContactEmail[]>([]);
  const [contactemail2, setContactEmail2] = useState<ContactEmail2[]>([]);

  //Editing of Phone
  const [contactphone, setContactPhone] = useState<ContactPhone[]>([]);
  const [contactphone2, setContactPhone2] = useState<ContactPhone2[]>([]);

  //Editing of Company
  const [contactcompany, setContactCompany] = useState<ContactCompany[]>([]);
  const [contactcompany2, setContactCompany2] = useState<ContactCompany2[]>([]);

  //
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const {
    getContacts,
    getContactByCIDN,
    getContactAddressByCIDN,
    getContactEmailByCIDN,
    getContactPhoneByCIDN,
    getContactCompanyByCIDN,
    getStateProvince,
    getContactsToMatch,
    UpdateContactMatchStatus,
    ContactMatch,
    addUserTracking,
    AddManualContactMatch,
  } = useAPI();
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  //Load The Contact Information

  const fetchContactMatches = useCallback(
    async (cidn1: number, cidn2: number) => {
      try {
        setIsLoading(true);
        setError("");
        const response = await getContactsToMatch();

        if (response?.data) {
          if (cidn1 > 0 && cidn2 > 0) {
            const filteredContacts = response.data.filter(
              (contact: ContactsToMatch) =>
                contact.cidn1 === cidn1 && contact.cidn2 === cidn2,
            );
            setContacts(filteredContacts);
          } else {
            setContacts(response.data);
          }
        } else {
          throw new Error("Failed to fetch contacts");
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
      } finally {
        setIsLoading(false);
      }
    },
    [getContactsToMatch],
  );

  const fetchContact = async (cidn1: number, cidn2: number) => {
    try {
      if (!cidn1 || !cidn2) {
        return;
      }
      const response = await getContactByCIDN(cidn1);

      if (response?.data && response.data.length > 0) {
        setContact(response.data[0]);

        updateContactField("firstnameselected", true);

        updateContactField("lastnameselected", true);

        updateContactField("middlenameselected", true);
      } else {
        throw new Error("Failed to fetch contact");
      }

      const response2 = await getContactByCIDN(cidn2);

      if (response2?.data && response2.data.length > 0) {
        setContact2(response2.data[0]);
      } else {
        throw new Error("Failed to fetch contact 2");
      }
    } catch (err) {
      console.error("Error fetching contact:", err);
      setError(
        err instanceof Error
          ? err.message
          : "An error occurred fetching contact by cidn",
      );
    }
  };

  useEffect(() => {
    fetchContactMatches(0, 0);
  }, [getContactsToMatch]);

  //Populate Address Grid
  const fetchContactAddressByCIDN = useCallback(
    async (cidn1: number, cidn2: number) => {
      if (!cidn1 || !cidn2) return;
      const res = await getContactAddressByCIDN(Number(cidn1));

      setContactAddress(res.data);
      //this sets the first address as the selected default
      setContactAddress((prev) =>
        prev.map((item, index) => ({
          ...item,
          addressselected: index === 0,
        })),
      );

      // updateAddressField("addressselected", true);
      const res2 = await getContactAddressByCIDN(Number(cidn2));

      setContactAddress2(res2.data);
      //this sets the first address in contact 2, if there is one, as the selected default if contact 1 doesn't have any addresses
      if (res.data.length === 0 && res2.data.length > 0) {
        setContactAddress2((prev) =>
          prev.map((item, index) => ({
            ...item,
            addressselected: index === 0,
          })),
        );
      }
    },
    [],
  );

  //Populate Email Grid
  const fetchContactEmailByCIDN = useCallback(
    async (cidn1: number, cidn2: number) => {
      if (!cidn1 || !cidn2) return;
      const res = await getContactEmailByCIDN(Number(cidn1));

      setContactEmail(res.data);
      //this sets the first email as the selected default
      setContactEmail((prev) =>
        prev.map((item, index) => ({
          ...item,
          emailselected: index === 0,
        })),
      );

      const res2 = await getContactEmailByCIDN(Number(cidn2));

      setContactEmail2(res2.data);
      //this sets the first email in contact 2, if there is one, as the selected default if contact 1 doesn't have any emails
      if (res.data.length === 0 && res2.data.length > 0) {
        setContactEmail2((prev) =>
          prev.map((item, index) => ({
            ...item,
            emailselected: index === 0,
          })),
        );
      }
    },
    [],
  );

  //Populate Phone Grid
  const fetchContactPhoneByCIDN = useCallback(
    async (cidn1: number, cidn2: number) => {
      if (!cidn1 || !cidn2) return;
      const res = await getContactPhoneByCIDN(Number(cidn1));

      setContactPhone(res.data);
      //this sets the first phone number as the selected default
      setContactPhone((prev) =>
        prev.map((item, index) => ({
          ...item,
          phoneselected: index === 0,
        })),
      );

      const res2 = await getContactPhoneByCIDN(Number(cidn2));

      setContactPhone2(res2.data);
      //this sets the first phone number in contact 2, if there is one, as the selected default if contact 1 doesn't have any phone numbers
      if (res.data.length === 0 && res2.data.length > 0) {
        setContactPhone2((prev) =>
          prev.map((item, index) => ({
            ...item,
            phoneselected: index === 0,
          })),
        );
      }
    },
    [],
  );

  //Populate Company Grid
  const fetchContactCompanyByCIDN = useCallback(
    async (cidn1: number, cidn2: number) => {
      if (!cidn1 || !cidn2) return;
      const res = await getContactCompanyByCIDN(Number(cidn1));

      setContactCompany(res.data);
      //this sets the first company as the selected default
      setContactCompany((prev) =>
        prev.map((item, index) => ({
          ...item,
          companyselected: index === 0,
        })),
      );

      const res2 = await getContactCompanyByCIDN(Number(cidn2));

      setContactCompany2(res2.data);
      //this sets the first company in contact 2, if there is one, as the selected default if contact 1 doesn't have any companies
      if (res.data.length === 0 && res2.data.length > 0) {
        setContactCompany2((prev) =>
          prev.map((item, index) => ({
            ...item,
            companyselected: index === 0,
          })),
        );
      }
    },
    [],
  );

  const formatPhoneNumber = (phoneNumber: string): string => {
    // Remove all non-digit characters
    const cleaned = phoneNumber.replace(/\D/g, "");

    // If the number is 11 digits and starts with 1 (US number)
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      const usNumber = cleaned.slice(1);
      return `(${usNumber.slice(0, 3)}) ${usNumber.slice(
        3,
        6,
      )}-${usNumber.slice(6)}`;
    }

    // If the number is 10 digits (US number without country code)
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6,
      )}`;
    }

    // For international numbers, format as +XX XXX XXX XXXX
    // This handles numbers with country codes of varying lengths
    const countryCode = cleaned.slice(0, cleaned.length - 10);
    const nationalNumber = cleaned.slice(cleaned.length - 10);

    return `+${countryCode} ${nationalNumber.slice(
      0,
      3,
    )} ${nationalNumber.slice(3, 6)} ${nationalNumber.slice(6)}`;
  };

  const updateContactField = <K extends keyof Contact>(
    field: K,
    value: Contact[K],
  ) => {
    setContact((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const updateContact2Field = <K extends keyof Contact2>(
    field: K,
    value: Contact2[K],
  ) => {
    setContact((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const updateAddressField = <K extends keyof ContactAddress>(
    field: K,
    value: ContactAddress[K],
  ) => {
    setContactAddress((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const updateAddress2Field = <K extends keyof ContactAddress2>(
    field: K,
    value: ContactAddress2[K],
  ) => {
    setContactAddress2((prev) => (prev ? { ...prev, [field]: value } : prev));
  };

  const handleAddMatch = async () => {
    if (
      selectedcidn1 === 0 ||
      selectedcidn2 === 0 ||
      selectedcidn1 === selectedcidn2
    ) {
      alert("Please select two different contacts to match.");
      return;
    }
    const response = await AddManualContactMatch(
      selectedcidn1,
      selectedcidn2,
      user!.id,
    );
    setIsAddingContact(false);
    alert(response[0].match_manual_add);
    await fetchContactMatches(0, 0);
  };

  const handleCancelAddMatch = () => {
    setIsAddingContact(false);
  };

  const handleReturn = () => {
    navigate("/contact-management");
  };

  const handleAdd = async () => {
    try {
      setIsAddingContact(true);
      setError("");
      const response = await getContacts("");

      if (response?.data) {
        setContactDropDown(response.data);
        setContactMatchDropDown(response.data);
      } else {
        throw new Error("Failed to fetch contacts");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    }
  };

  const handleDetails = (cidn1: number, cidn2: number) => {
    setSelectedCidn1(cidn1);
    setSelectedCidn2(cidn2);
    setViewDetails(true);
    fetchContactMatches(cidn1, cidn2);
    fetchContact(cidn1, cidn2);
    fetchContactAddressByCIDN(cidn1, cidn2);
    fetchContactEmailByCIDN(cidn1, cidn2);
    fetchContactPhoneByCIDN(cidn1, cidn2);
    fetchContactCompanyByCIDN(cidn1, cidn2);
  };

  const handleMatch = async (cidn1: number, cidn2: number) => {
    setViewDetails(false);
    const firstname: string =
      (contact2?.firstnameselected ? contact2.firstname : contact?.firstname) ??
      "";
    const lastname: string =
      (contact2?.lastnameselected ? contact2.lastname : contact?.lastname) ??
      "";
    const middlename: string =
      (contact2?.middlenameselected
        ? contact2.middlename
        : contact?.middlename) ?? "";
    let addressid: number = 0;
    let emailid: number = 0;
    let phoneid: number = 0;
    let companyid: number = 0;
    const selectedAddress = contactaddress.find(
      (address) => address.addressselected,
    );
    if (selectedAddress) {
      addressid = selectedAddress.contactaddressid;
    } else {
      const selectedAddress2 = contactaddress2.find(
        (address2) => address2.addressselected,
      );
      if (selectedAddress2) {
        addressid = selectedAddress2.contactaddressid;
      }
    }
    const selectedEmail = contactemail.find((email) => email.emailselected);
    if (selectedEmail) {
      emailid = selectedEmail.contactemailid;
    } else {
      const selectedEmail2 = contactemail2.find(
        (email2) => email2.emailselected,
      );
      if (selectedEmail2) {
        emailid = selectedEmail2.contactemailid;
      }
    }
    const selectedPhone = contactphone.find((phone) => phone.phoneselected);
    if (selectedPhone) {
      phoneid = selectedPhone.contactphoneid;
    } else {
      const selectedPhone2 = contactphone2.find(
        (phone2) => phone2.phoneselected,
      );
      if (selectedPhone2) {
        phoneid = selectedPhone2.contactphoneid;
      }
    }
    const selectedCompany = contactcompany.find(
      (company) => company.companyselected,
    );
    if (selectedCompany) {
      companyid = selectedCompany.contactcompanyid;
    } else {
      const selectedCompany2 = contactcompany2.find(
        (company2) => company2.companyselected,
      );
      if (selectedCompany2) {
        companyid = selectedCompany2.contactcompanyid;
      }
    }
    await ContactMatch(
      Number(cidn1),
      Number(cidn2),
      firstname,
      middlename,
      lastname,
      addressid,
      emailid,
      phoneid,
      companyid,
    );
    await UpdateContactMatchStatus(
      Number(cidn1),
      Number(cidn2),
      "Matched",
      user!.id,
    );

    //Update user activity
    const metadata = JSON.stringify({
      page: location.pathname,
      device: isMobile ? "mobile" : "desktop",
    });

    addUserTracking(user!.id, "Contact Match", user!.id, metadata);

    await fetchContactMatches(0, 0);

    const matchMessage =
      "Contacts have been merged.   Please review the contact details from the contact management page to ensure the correct information is in place for the master contact record and make any necessary edits.";
    alert(matchMessage);
  };
  const handleSeparate = async (cidn1: number, cidn2: number) => {
    setViewDetails(false);
    await UpdateContactMatchStatus(
      Number(cidn1),
      Number(cidn2),
      "Separate",
      user!.id,
    );

    //Update user activity
    const metadata = JSON.stringify({
      page: location.pathname,
      device: isMobile ? "mobile" : "desktop",
    });

    addUserTracking(user!.id, "Contact Separate", user!.id, metadata);

    await fetchContactMatches(0, 0);
    const separateMessage = "Contacts have been marked as separate";
    alert(separateMessage);
  };

  const handleCancel = () => {
    setSelectedCidn1(0);
    setSelectedCidn2(0);
    setViewDetails(false);
    fetchContactMatches(0, 0);
  };

  const handleContactCheckbox = (
    field: keyof Contact,
    source: "contact" | "contact2",
    checked: boolean,
  ) => {
    if (source === "contact") {
      setContact((prev) => (prev ? { ...prev, [field]: checked } : prev));
      setContact2((prev) => (prev ? { ...prev, [field]: !checked } : prev));
    } else {
      setContact2((prev) => (prev ? { ...prev, [field]: checked } : prev));
      setContact((prev) => (prev ? { ...prev, [field]: !checked } : prev));
    }
  };

  const handleAddressCheckbox = (
    id: number,
    source: "Address" | "Address2",
    checked: boolean,
  ) => {
    if (!checked) return; // prevent unchecking everything

    // Update ContactAddress
    setContactAddress((prev) =>
      prev.map((item) => ({
        ...item,
        addressselected: source === "Address" && item.contactaddressid === id,
      })),
    );

    // Update ContactAddress2
    setContactAddress2((prev) =>
      prev.map((item) => ({
        ...item,
        addressselected: source === "Address2" && item.contactaddressid === id,
      })),
    );
  };

  const handleEmailCheckbox = (
    id: number,
    source: "Email" | "Email2",
    checked: boolean,
  ) => {
    if (!checked) return; // prevent unchecking everything

    // Update ContactEmail
    setContactEmail((prev) =>
      prev.map((item) => ({
        ...item,
        emailselected: source === "Email" && item.contactemailid === id,
      })),
    );

    // Update ContactEmail2
    setContactEmail2((prev) =>
      prev.map((item) => ({
        ...item,
        emailselected: source === "Email2" && item.contactemailid === id,
      })),
    );
  };

  const handlePhoneCheckbox = (
    id: number,
    source: "Phone" | "Phone2",
    checked: boolean,
  ) => {
    if (!checked) return; // prevent unchecking everything

    // Update ContactPhone
    setContactPhone((prev) =>
      prev.map((item) => ({
        ...item,
        phoneselected: source === "Phone" && item.contactphoneid === id,
      })),
    );

    // Update ContactPhone2
    setContactPhone2((prev) =>
      prev.map((item) => ({
        ...item,
        phoneselected: source === "Phone2" && item.contactphoneid === id,
      })),
    );
  };

  const handleCompanyCheckbox = (
    id: number,
    source: "Company" | "Company2",
    checked: boolean,
  ) => {
    if (!checked) return; // prevent unchecking everything

    // Update ContactCompany
    setContactCompany((prev) =>
      prev.map((item) => ({
        ...item,
        companyselected: source === "Company" && item.contactcompanyid === id,
      })),
    );

    // Update ContactCompany2
    setContactCompany2((prev) =>
      prev.map((item) => ({
        ...item,
        companyselected: source === "Company2" && item.contactcompanyid === id,
      })),
    );
  };

  const handleSort = (key: keyof ContactsToMatch) => {
    let direction: "ascending" | "descending" | null = "ascending";

    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        direction = "descending";
      } else if (sortConfig.direction === "descending") {
        direction = null;
      }
    }

    setSortConfig({ key, direction });
  };

  const getSortedContacts = () => {
    let filteredContacts = contacts;

    if (!sortConfig.key || !sortConfig.direction) {
      return filteredContacts;
    }

    return [...filteredContacts].sort((a, b) => {
      const aValue = a[sortConfig.key!];
      const bValue = b[sortConfig.key!];

      // Handle different data types
      let aStr: string;
      let bStr: string;

      if (Array.isArray(aValue)) {
        aStr = aValue.join(", ");
        bStr = Array.isArray(bValue) ? bValue.join(", ") : "";
      } else if (typeof aValue === "boolean") {
        aStr = aValue ? "Yes" : "No";
        bStr = typeof bValue === "boolean" ? (bValue ? "Yes" : "No") : "";
      } else if (typeof aValue === "number") {
        aStr = aValue.toString();
        bStr = typeof bValue === "number" ? bValue.toString() : "";
      } else {
        aStr = aValue ? aValue.toString().toLowerCase() : "";
        bStr = bValue ? bValue.toString().toLowerCase() : "";
      }

      if (aStr < bStr) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aStr > bStr) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  const getSortIcon = (columnKey: keyof ContactsToMatch) => {
    if (sortConfig.key !== columnKey) {
      return <FontAwesomeIcon icon={faSort} />;
    }
    return sortConfig.direction === "ascending" ? (
      <FontAwesomeIcon icon={faSortUp} />
    ) : (
      <FontAwesomeIcon icon={faSortDown} />
    );
  };

  return (
    <div className="generalPage">
      <Header2 />
      <div className="contactmanagement-container">
        <div className="pageContainer">
          <div className="button-container">
            <button className="back-button" onClick={() => navigate("/")}>
              <FontAwesomeIcon icon={faArrowLeft} /> Back to Home
            </button>
          </div>
          <div className="contactmanagement-header">
            <div className="contactmanagement-actions">
              <h1 className="contactmanagement-title">Contact Matching</h1>

              <button onClick={handleAdd} className="add-user-button">
                Manually Add to Match List{" "}
              </button>
              <button onClick={handleReturn} className="add-user-button">
                Return to Contact Management
              </button>
            </div>
          </div>
          {isAddingContact && (
            <div className="add-match-panel">
              <div className="match-row">
                <div className="matchtitle">Manually Add to Match List</div>
              </div>
              <div className="match-row">
                <div className="field">
                  <label>Select Contact</label>
                  <select
                    id="cidn"
                    name="cidn"
                    onChange={(e) => {
                      const selected = contactdropdown.find(
                        (u) => String(u.cidn) === e.target.value,
                      );

                      if (!selected) return;

                      setSelectedCidn1(Number(selected.cidn));
                    }}
                  >
                    <option value="">-- Select Contact --</option>
                    {contactdropdown.map((ul) => (
                      <option key={ul.cidn} value={ul.cidn}>
                        {ul.lastname}, {ul.firstname} {ul.middlename}:{" "}
                        {ul.email}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field">
                  <label>Select Contact to Match</label>
                  <select
                    id="cidn2"
                    name="cidn2"
                    onChange={(e) => {
                      const selected = contactmatchdropdown.find(
                        (u) => String(u.cidn) === e.target.value,
                      );

                      if (!selected) return;

                      setSelectedCidn2(Number(selected.cidn));
                    }}
                  >
                    <option value="">-- Select Contact to Match --</option>
                    {contactmatchdropdown.map((ul) => (
                      <option key={ul.cidn} value={ul.cidn}>
                        {ul.lastname}, {ul.firstname} {ul.middlename}:{" "}
                        {ul.email}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="match-row">
                <div className="field"></div>
                <div className="field"></div>
              </div>
              <div className="match-row">
                <div className="field button-right">
                  <button
                    onClick={handleAddMatch}
                    className="action-button match-button"
                  >
                    Add To Match List
                  </button>
                </div>

                <div className="field button-left">
                  <button
                    onClick={handleCancelAddMatch}
                    className="action-button canceldetail-button"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {error && <div className="error-message">{error}</div>}
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <div className="loading-text">Loading...</div>
            </div>
          ) : (
            <div className="contactmatch-table-container">
              <table className="contactmatch-table">
                <thead className="contactmatch-table-section-header ">
                  <tr>
                    <th
                      onClick={() => handleSort("cidn1")}
                      className="contactmatch-sortable-header"
                    >
                      CIDN{getSortIcon("cidn1")}
                    </th>
                    <th
                      onClick={() => handleSort("lastname1")}
                      className="contactmatch-sortable-header"
                    >
                      Last Name {getSortIcon("lastname1")}
                    </th>
                    <th
                      onClick={() => handleSort("firstname1")}
                      className="contactmatch-sortable-header"
                    >
                      First Name {getSortIcon("firstname1")}
                    </th>
                    <th
                      onClick={() => handleSort("middlename1")}
                      className="contactmatch-sortable-header"
                    >
                      Middle Name {getSortIcon("middlename1")}
                    </th>
                    <th
                      onClick={() => handleSort("score")}
                      className="contactmatch-sortable-header"
                    >
                      Score {getSortIcon("score")}
                    </th>
                    <th
                      onClick={() => handleSort("cidn2")}
                      className="contactmatch-sortable-header"
                    >
                      CIDN <br />
                      To
                      <br />
                      Match{getSortIcon("cidn2")}
                    </th>
                    <th
                      onClick={() => handleSort("lastname2")}
                      className="contactmatch-sortable-header"
                    >
                      Last Name <br />
                      To Match {getSortIcon("lastname2")}
                    </th>
                    <th
                      onClick={() => handleSort("firstname2")}
                      className="contactmatch-sortable-header"
                    >
                      First Name <br />
                      To Match{getSortIcon("firstname2")}
                    </th>
                    <th
                      onClick={() => handleSort("middlename2")}
                      className="contactmatch-sortable-header"
                    >
                      Middle Name <br />
                      To Match{getSortIcon("middlename2")}
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {getSortedContacts().map((user, index) => (
                    <tr
                      key={`${user.cidn1}-${user.lastname1}-${index}`}
                      className="table-row"
                    >
                      <td>{user.cidn1}</td>
                      <td>{user.lastname1}</td>
                      <td>{user.firstname1}</td>
                      <td>{user.middlename1}</td>
                      <td
                        className={
                          user.score < 51
                            ? "score-low"
                            : user.score > 80
                              ? "score-high"
                              : "score-medium"
                        }
                      >
                        {user.score === 0 ? "Manual Add" : user.score}
                      </td>
                      <td>{user.cidn2}</td>
                      <td>{user.lastname2}</td>
                      <td>{user.firstname2}</td>
                      <td>{user.middlename2}</td>
                      <td>
                        {!ViewDetails ? (
                          <button
                            onClick={() =>
                              handleDetails(user.cidn1, user.cidn2)
                            }
                            className="action-button view-details"
                          >
                            View Details
                          </button>
                        ) : (
                          <>
                            <button
                              onClick={() =>
                                handleMatch(user.cidn1, user.cidn2)
                              }
                              className="action-button match-button"
                            >
                              Match
                            </button>

                            <button
                              onClick={() =>
                                handleSeparate(user.cidn1, user.cidn2)
                              }
                              className="action-button separate-button"
                            >
                              Separate
                            </button>
                            <button
                              onClick={() => handleCancel()}
                              className="action-button canceldetail-button"
                            >
                              Cancel
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* only show details if they've clicked a details button */}
          {ViewDetails && (
            <div>
              {/* details for contact 1 */}
              <div className="contactsmatch-tables-wrapper">
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "30%" }} /> {/* Main text column */}
                      <col style={{ width: "60%" }} /> {/* second column */}
                      <col style={{ width: "10%" }} /> {/* second column */}
                    </colgroup>
                    <thead>
                      <th
                        colSpan={3}
                        className="contactsmatchdetail-table-section-header"
                      >
                        <div className="header-contact">
                          <span>Contact Details</span>
                        </div>
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <th>First Name</th>
                        <td>{contact?.firstname}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={contact?.firstnameselected ?? false}
                            onChange={(e) =>
                              handleContactCheckbox(
                                "firstnameselected",
                                "contact",
                                e.target.checked,
                              )
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Middle Name</th>
                        <td>{contact?.middlename}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={contact?.middlenameselected ?? false}
                            onChange={(e) =>
                              handleContactCheckbox(
                                "middlenameselected",
                                "contact",
                                e.target.checked,
                              )
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        <th>Last Name</th>
                        <td>{contact?.lastname}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={contact?.lastnameselected ?? false}
                            onChange={(e) =>
                              handleContactCheckbox(
                                "lastnameselected",
                                "contact",
                                e.target.checked,
                              )
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        <th>Professions</th>
                        <td colSpan={2}>
                          <div className="contactsdetail-wrap-text">
                            {contact?.profession?.join(", ")}
                            {contact?.profession_other &&
                              contact?.profession?.includes("Other") && (
                                <span> ({contact.profession_other})</span>
                              )}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Interests</th>
                        <td colSpan={2}>
                          <div className="contactsdetail-wrap-text">
                            {contact?.interests?.join(", ")}
                            {contact?.interests_other &&
                              contact?.interests?.includes("Other") && (
                                <span> ({contact.interests_other})</span>
                              )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Date Added</th>
                        <td colSpan={2}>{contact?.dateadded}</td>
                      </tr>
                      <tr>
                        <th>Date Updated</th>
                        <td colSpan={2}>{contact?.dateupdated}</td>
                      </tr>
                      <tr>
                        <th>Data Source</th>
                        <td colSpan={2}>{contact?.datasource}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* details for contact 2 */}
                <div className="contactsview-table-container ">
                  <table className="contactsmatchdetail-table ">
                    <colgroup>
                      <col style={{ width: "30%" }} /> {/* Main text column */}
                      <col style={{ width: "60%" }} /> {/* second column */}
                      <col style={{ width: "10%" }} /> {/* second column */}
                    </colgroup>
                    <thead>
                      <th
                        colSpan={3}
                        className="contactsmatchdetail-table-section-header"
                      >
                        <div className="header-contact">
                          <span>Contact To Match Details</span>
                        </div>
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <th>First Name</th>
                        <td>{contact2?.firstname}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={contact2?.firstnameselected ?? false}
                            onChange={(e) =>
                              handleContactCheckbox(
                                "firstnameselected",
                                "contact2",
                                e.target.checked,
                              )
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Middle Name</th>
                        <td>{contact2?.middlename}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={contact2?.middlenameselected ?? false}
                            onChange={(e) =>
                              handleContactCheckbox(
                                "middlenameselected",
                                "contact2",
                                e.target.checked,
                              )
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        <th>Last Name</th>
                        <td>{contact2?.lastname}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={contact2?.lastnameselected ?? false}
                            onChange={(e) =>
                              handleContactCheckbox(
                                "lastnameselected",
                                "contact2",
                                e.target.checked,
                              )
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        <th>Professions</th>
                        <td colSpan={2}>
                          <div className="contactsdetail-wrap-text">
                            {contact2?.profession?.join(", ")}
                            {contact2?.profession_other &&
                              contact2?.profession?.includes("Other") && (
                                <span> ({contact2.profession_other})</span>
                              )}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>Interests</th>
                        <td colSpan={2}>
                          <div className="contactsdetail-wrap-text">
                            {contact2?.interests?.join(", ")}
                            {contact2?.interests_other &&
                              contact2?.interests?.includes("Other") && (
                                <span> ({contact2.interests_other})</span>
                              )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>Date Added</th>
                        <td colSpan={2}>{contact2?.dateadded}</td>
                      </tr>
                      <tr>
                        <th>Date Updated</th>
                        <td colSpan={2}>{contact2?.dateupdated}</td>
                      </tr>
                      <tr>
                        <th>Data Source</th>
                        <td colSpan={2}>{contact2?.datasource}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* address for contact 1 */}
              <div className="contactsmatch-tables-wrapper">
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "35%" }} /> {/* Main text column */}
                      <col style={{ width: "18%" }} /> {/* second column */}
                      <col style={{ width: "8%" }} /> {/* third column */}
                      <col style={{ width: "9%" }} /> {/* fourth column */}
                      <col style={{ width: "15%" }} /> {/* fifth column */}
                      <col style={{ width: "15%" }} /> {/* sixth column */}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={6}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Address Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip</th>
                        <th>Country</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactaddress.length > 0 ? (
                        contactaddress.map((ca) => {
                          const primaryaddressind = "*";
                          return (
                            <tr key={ca.contactaddressid}>
                              <td>
                                {ca.primaryind &&
                                  contactaddress.length > 1 &&
                                  primaryaddressind}{" "}
                                {ca.streetaddress}
                                {ca.streetaddress2 && (
                                  <>
                                    <br />
                                    {ca.streetaddress2}
                                  </>
                                )}
                              </td>
                              <td>{ca.city}</td>
                              <td>{ca.state}</td>
                              <td>{ca.zip}</td>
                              <td>{ca.country}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={ca?.addressselected ?? false}
                                  onChange={(e) =>
                                    handleAddressCheckbox(
                                      ca.contactaddressid,
                                      "Address",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={6} className="not-active-text">
                            No addresses linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* address for contact 2 */}
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "35%" }} /> {/* Main text column */}
                      <col style={{ width: "18%" }} /> {/* second column */}
                      <col style={{ width: "8%" }} /> {/* third column */}
                      <col style={{ width: "9%" }} /> {/* fourth column */}
                      <col style={{ width: "15%" }} /> {/* fifth column */}
                      <col style={{ width: "15%" }} /> {/* sixth column */}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={6}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Address To Match Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip</th>
                        <th>Country</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactaddress2.length > 0 ? (
                        contactaddress2.map((ca2) => {
                          const primaryaddressind = "*";
                          return (
                            <tr key={ca2.contactaddressid}>
                              <td>
                                {ca2.primaryind &&
                                  contactaddress2.length > 1 &&
                                  primaryaddressind}{" "}
                                {ca2.streetaddress}
                                {ca2.streetaddress2 && (
                                  <>
                                    <br />
                                    {ca2.streetaddress2}
                                  </>
                                )}
                              </td>
                              <td>{ca2.city}</td>
                              <td>{ca2.state}</td>
                              <td>{ca2.zip}</td>
                              <td>{ca2.country}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={ca2?.addressselected ?? false}
                                  onChange={(e) =>
                                    handleAddressCheckbox(
                                      ca2.contactaddressid,
                                      "Address2",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={6} className="not-active-text">
                            No addresses linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* email for contact 1 */}
              <div className="contactsmatch-tables-wrapper">
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "85%" }} /> {/* Main text column */}
                      <col style={{ width: "15%" }} />{" "}
                      {/* secondary text column */}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={2}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Email Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Email</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactemail.length > 0 ? (
                        contactemail.map((ce) => {
                          const primaryemailind = "*";

                          return (
                            <tr key={ce.contactemailid}>
                              <td>
                                {ce.primaryind && primaryemailind} {ce.email}
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={ce?.emailselected ?? false}
                                  onChange={(e) =>
                                    handleEmailCheckbox(
                                      ce.contactemailid,
                                      "Email",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={2} className="not-active-text">
                            No email addresses linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* emails for contact 2 */}
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "85%" }} /> {/* Main text column */}
                      <col style={{ width: "15%" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={2}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Email To Match Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Email</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactemail2.length > 0 ? (
                        contactemail2.map((ce2) => {
                          const primaryemail2ind = "*";

                          return (
                            <tr key={ce2.contactemailid}>
                              <td>
                                {ce2.primaryind && primaryemail2ind} {ce2.email}
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={ce2?.emailselected ?? false}
                                  onChange={(e) =>
                                    handleEmailCheckbox(
                                      ce2.contactemailid,
                                      "Email2",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={2} className="not-active-text">
                            No email addresses linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* phone for contact 1 */}
              <div className="contactsmatch-tables-wrapper">
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "50%" }} /> {/* Main text column */}
                      <col style={{ width: "35%" }} /> {/* Secondary 1 */}
                      <col style={{ width: "15%" }} /> {/* Primary */}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={3}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Phone Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Phone Number</th>
                        <th>Phone Ext</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactphone.length > 0 ? (
                        contactphone.map((cp) => {
                          const primaryphoneind = "*";

                          return (
                            <tr key={cp.contactphoneid}>
                              <td>
                                {cp.primaryind && primaryphoneind}{" "}
                                {formatPhoneNumber(
                                  `${cp.countrycode || ""}${cp.phonenumber || ""}`,
                                )}
                              </td>

                              <td>{cp.phoneext}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={cp?.phoneselected ?? false}
                                  onChange={(e) =>
                                    handlePhoneCheckbox(
                                      cp.contactphoneid,
                                      "Phone",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={3} className="not-active-text">
                            No phone numbers linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* phone for contact 2 */}
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "50%" }} /> {/* Main text column */}
                      <col style={{ width: "35%" }} /> {/* Secondary 1 */}
                      <col style={{ width: "15%" }} /> {/* Primary */}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={3}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Phone To Match Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Phone Number</th>
                        <th>Phone Ext</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactphone2.length > 0 ? (
                        contactphone2.map((cp2) => {
                          const primaryphoneind = "*";

                          return (
                            <tr key={cp2.contactphoneid}>
                              <td>
                                {cp2.primaryind && primaryphoneind}{" "}
                                {formatPhoneNumber(
                                  `${cp2.countrycode || ""}${cp2.phonenumber || ""}`,
                                )}
                              </td>

                              <td>{cp2.phoneext}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={cp2?.phoneselected ?? false}
                                  onChange={(e) =>
                                    handlePhoneCheckbox(
                                      cp2.contactphoneid,
                                      "Phone2",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={3} className="not-active-text">
                            No phone numbers linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="contactsmatch-tables-wrapper">
                {/* Company for contact 1 */}
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "40%" }} /> {/* Main text column */}
                      <col style={{ width: "30%" }} /> {/* Secondary 1 */}
                      <col style={{ width: "15%" }} /> {/* third column */}
                      <col style={{ width: "15%" }} /> {/*primary ind*/}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={4}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Company Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Company Name</th>
                        <th>Type</th>
                        <th>Title</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactcompany.length > 0 ? (
                        contactcompany.map((cc) => {
                          const primarycompind = "*";

                          return (
                            <tr key={cc.contactcompanyid}>
                              <td>
                                {cc.primaryind && primarycompind}{" "}
                                {cc.companyname}
                              </td>

                              <td>{cc.entitytype}</td>

                              <td>{cc.title}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={cc?.companyselected ?? false}
                                  onChange={(e) =>
                                    handleCompanyCheckbox(
                                      cc.contactcompanyid,
                                      "Company",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={4} className="not-active-text">
                            No companies linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* Company for contact 2 */}
                <div className="contactsview-table-container">
                  <table className="contactsmatchdetail-table">
                    <colgroup>
                      <col style={{ width: "40%" }} /> {/* Main text column */}
                      <col style={{ width: "30%" }} /> {/* Secondary 1 */}
                      <col style={{ width: "15%" }} /> {/* third column */}
                      <col style={{ width: "15%" }} /> {/*primary ind*/}
                    </colgroup>
                    <thead>
                      <tr>
                        <th
                          colSpan={4}
                          className="contactsmatchdetail-table-section-header"
                        >
                          <div className="header-contact">
                            <span>Company To Match Details</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Company Name</th>
                        <th>Type</th>
                        <th>Title</th>
                        <th>Select Primary</th>
                      </tr>

                      {contactcompany2.length > 0 ? (
                        contactcompany2.map((cc2) => {
                          const primarycompind = "*";

                          return (
                            <tr key={cc2.contactcompanyid}>
                              <td>
                                {cc2.primaryind && primarycompind}{" "}
                                {cc2.companyname}
                              </td>

                              <td>{cc2.entitytype}</td>

                              <td>{cc2.title}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={cc2?.companyselected ?? false}
                                  onChange={(e) =>
                                    handleCompanyCheckbox(
                                      cc2.contactcompanyid,
                                      "Company2",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={4} className="not-active-text">
                            No companies linked to this contact
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
